/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

(function() {
  tinymce.PluginManager.add("upload_image", function (editor) {
    editor.addCommand("upload_image", function() {
      var input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');

      input.onchange = startLoading;

      function startLoading() {
        var file = input.files[0];

        if (!/^image\//.test(file.type)) {
          return;
        }

        var reader = new FileReader();
        reader.onload = function() {
          embedImage(reader.result);
        };
        reader.readAsDataURL(file);
      }

      function embedImage(content) {
        editor.undoManager.transact(function () {
          editor.selection.setContent(editor.dom.createHTML('img', {src: content}));

          editor.editorUpload.uploadImagesAuto();
        });
      }

      input.click();
    });

    editor.ui.registry.addButton("upload_image", {
      icon: "image",
      context: "insert",
      title: "Insert image",
      onAction: function () {
        editor.execCommand("upload_image");
      }
    });

    editor.ui.registry.addMenuItem("upload_image", {
      cmd: "upload_image",
      context: "insert",
      text: "Insert image",
      icon: "image"
    });
  });
}());
